export const ultimasNoticias = [
    // {
    //     "imagen" : "image/transparencia2025.png",
    //     "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/contraloriat/dir1/2025/48rubros/1erTrimestre/fraccion15a/TC_Conv%20Nal_HGO.pdf",
    //     "titulo" : "Concurso Nacional Transparencia en Corto 2025",
    //     "fecha" : ""
    // },
    // {
    //     "imagen" : "image/dryc2025.jpg",
    //     "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/interes/ConvocaDRYC.pdf",
    //     "titulo" : "Convocatoria para obtener el Registro o Refrendo de Director Responsable y Corresponsable (DRyC)",
    //     "fecha" : "11 de marzo de 2025 al 10 de julio de 2025"
    // },
    // {
    //     "imagen" : "image/construyeTuCamino-1.jpg",
    //     "url" : "/ConstruyeTuCamino",
    //     // "titulo" : "Construye Tu Camino",
    //     // "fecha" : ""
    // },
    {
        "imagen" : "image/obras.jpg",
        "url" : "https://innovacion-sopot.hidalgo.gob.mx/view/public/?controller=sopot_works&view=works_by_year",
        "titulo" : "Obras que se estan ejecutando en los 84 municipios del estado.",
        "fecha" : ""
    },
]